import { render, staticRenderFns } from "./ButtonAddMenuItem.vue?vue&type=template&id=77d0cf36&scoped=true&"
import script from "./ButtonAddMenuItem.vue?vue&type=script&lang=js&"
export * from "./ButtonAddMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAddMenuItem.vue?vue&type=style&index=0&id=77d0cf36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d0cf36",
  null
  
)

export default component.exports